import { settingsStringParsing } from '@orbital/games-frontend-library'
// import { defaultSettingsReceive } from './defaultSettings'

export const helperReceiveSettings = (
  str: string,
  setStakes: any,
  setaudio: any,
  maxBet: any
) => {
  const defaultSettingsReceive = [
    { name: 'stake', minStake: '0', maxStake: maxBet },
    { name: 'sound' },
    { name: 'music' },
    { name: 'volume' },
  ]

  const [ante, sound, music, volume] = settingsStringParsing(
    str,
    defaultSettingsReceive,
  )
  setStakes({ ante })
  setaudio({ music, sound, volume })
}
